<template>
  <div>
    <my-header>
      正云人工智能DEMO
      <template #right>
        <van-icon class-prefix="iconfont" name="icon-config" color="#333333" @click="showConfig" />
        <van-popup v-model="configShow">
          <van-field label="切换相机">
            <template #input>
              <van-radio-group v-model="facingMode" @change="ToggleFacingMode">
                <van-radio name="user">前置</van-radio>
                <van-radio name="environment">后置</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-popup>
      </template>
    </my-header>
<!--    <van-cell title="选择题" is-link to="/select"></van-cell>-->
<!--    <van-cell title="判断题" is-link to="/judge"></van-cell>-->
    <van-cell title="一老一小" is-link to="/exercise/start"></van-cell>
<!--    <van-cell title="深蹲" is-link to="/squats"></van-cell>-->
<!--    <van-cell title="抬腿" is-link to="/knee-lift"></van-cell>-->
<!--    <van-cell title="开合跳" is-link to="/oc-jump"></van-cell>-->
<!--    <van-cell title="体侧屈" is-link to="/body-flexion"></van-cell>-->
<!--    <van-cell title="弯腰触地" is-link to="/bend-over"></van-cell>-->
<!--    <van-cell title="肩部拉伸" is-link to="/shoulder"></van-cell>-->
    <van-cell title="百工非遗" is-link to="/baigongfeiyi/bgHome"></van-cell>
    <van-cell title="数学研学" is-link to="/mathStudy"></van-cell>

  </div>
</template>
<script>
import { Hands, HAND_CONNECTIONS } from "@mediapipe/hands";
import { Camera } from "@mediapipe/camera_utils";
import { drawConnectors, drawLandmarks } from "@mediapipe/drawing_utils";
import { Field, Button, Toast, Cell, CellGroup, Icon, Row, Col, Popup, RadioGroup, Radio } from 'vant'

export default {
  name: "Home",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [Col.name]: Col,
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button
  },
  data: function() {
    return {
      facingMode: this.$store.getters.facingMode,
      configShow: false
    }
  },
  mounted() {
  },
  methods: {
    showConfig() {
      this.configShow = true
    },
    ToggleFacingMode() {
      this.$store.dispatch('app/toggleFacingMode')
    }
  }
}
</script>

<style scoped>
.output_canvas {
  width: 100%;
  height: 100%;
}
.question{
  position: absolute;
  text-align: center;
  width: 100%;
  font-size: 5rem;
}
</style>
